<div class="dialog-container">
    <div class="flex items-center justify-between gap-4 px-6 pt-5 pb-4 border-b border-slate-100">
        <div class="min-w-0">
            <h1 class="text-lg font-semibold text-slate-900">Master Controllers</h1>
            @if (!isLoading()) {
            <p class="text-xs text-slate-500">{{ assignments().length }} assigned</p>
            }
        </div>
        <div class="flex items-center gap-1">
            <button mat-flat-button color="primary" (click)="onAddNew()" class="mr-2">
                <mat-icon>add</mat-icon>
                Add Master Controller
            </button>
            <button mat-icon-button (click)="onRefresh()" [disabled]="isLoading()" matTooltip="Refresh">
                <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button (click)="onClose()" matTooltip="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <mat-dialog-content class="list-content">
        @if (!isLoading() && assignments().length === 0) {
        <div class="text-center py-10">
            <div class="inline-flex bg-blue-50 text-blue-600 p-3 rounded-lg mb-3">
                <mat-icon>device_hub</mat-icon>
            </div>
            <p class="text-slate-600">No master controllers assigned</p>
        </div>
        }

        @if (assignments().length > 0) {
        <div class="flex flex-col gap-2">
            @for (assignment of assignments(); track assignment.id) {
            <app-master-controller-item [assignment]="assignment" [isDeleting]="isDeleting() === assignment.id"
                (edit)="onEdit($event)" (delete)="onDelete($event)">
            </app-master-controller-item>
            }
        </div>
        }
    </mat-dialog-content>
</div>
